<template>
  <div>
    <b-tabs @input="selectVariation">
      <b-tab
        v-for="variation in variations"
        :key="variation.id"
        :title="`Supplier: ${variation.supplier.booking_name}`"
        class="pt-3"
      >
        <h3>Kontaktinformasjon</h3>
        <p>
          Kontaktinformasjon for <strong>{{ variation.supplier.booking_name }}</strong> i {{ variation.place.name }}
          <b-badge
            :variant="
              variation.status === 1
                ? 'primary'
                : variation.status === 2
                ? 'secondary'
                : variation.status === 0
                ? 'danger'
                : ''
            "
          >
            {{
              variation.status === 1
                ? 'Active'
                : variation.status === 2
                ? 'Bookable'
                : variation.status === 0
                ? 'Disabled'
                : ''
            }}
          </b-badge>
        </p>
        <b-table :items="supplierContactInfo(variation)">
          <template v-slot:cell(name)="{ item }">
            <strong style="text-transform: capitalize">{{ item.name }}</strong>
          </template>
        </b-table>
        <b-button
          v-if="Object.keys(variation).length"
          variant="default"
          class="mr-2"
          v-b-modal="`giftcard-${giftcard.id}`"
        >
          Redeem Giftcard
        </b-button>
      </b-tab>
      <b-tab title="Transactions" class="pt-3" lazy>
        <giftcard-history :giftcard="giftcard" />
      </b-tab>
    </b-tabs>
    <hr />
    <b-row align-h="end">
      <b-col cols="auto">
        <b-modal title="Redeem Giftcard" :id="`giftcard-${giftcard.id}`" hide-footer>
          <b-overlay :show="loading">
            <form @submit.prevent="redeemCode">
              <b-row align-v="end">
                <b-col>
                  <b-form-group label="Experienced at">
                    <b-form-datepicker v-model="experienced_at" :min="new Date()" />
                  </b-form-group>
                </b-col>
                <b-col cols="auto">
                  <b-button variant="primary" style="margin-bottom: 1rem" type="submit"> Redeem </b-button>
                </b-col>
              </b-row>
            </form>
          </b-overlay>
        </b-modal>

        <b-button variant="primary" @click.prevent="$emit('ok')">Ok</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { products, giftcard } from '@youwish1/api-package'
import GiftcardHistory from './GiftcardHistory.vue'

export default {
  name: 'OrderDetailInfo',
  components: { GiftcardHistory },
  props: { giftcard: { type: Object }, old_product_info_id: { default: null }, product_id: { default: null } },
  data() {
    return { variations: [], selectedVariation: {}, loading: false, experienced_at: '' }
  },
  beforeMount() {
    this.loadVariation()
  },
  methods: {
    supplierContactInfo(supplier) {
      const data = {}
      if (supplier.booking_phone) {
        data.telefonnummer = supplier.booking_phone
      }

      if (supplier.booking_phone_time) {
        data.telefontid = supplier.booking_phone_time
      }

      if (supplier.booking_email) {
        data['e-postadresse'] = supplier.booking_email
      }
      if (supplier.booking_address) {
        data.besoksadresse = `${supplier.booking_address}, ${supplier.booking_city} ${supplier.booking_postal_code}`
      }

      if (supplier.booking_website_url) {
        data.hjemmeside = supplier.booking_website_url
      }

      if (supplier.booking_url) {
        data.extern_booking = supplier.booking_url
      }

      return Object.entries(data).flatMap(([key, value]) => ({ name: key, value }))
    },
    selectVariation(index) {
      console.log(index)
      this.selectedVariation = this.variations[index]
      console.log(this.variations[index])
    },
    async loadVariation() {
      if (this.old_product_info_id) {
        const variations = await products.variations.all(this.product_id, {
          filter: {
            old_product_info_id: this.old_product_info_id,
          },
        })
        this.variations = variations.data()
        this.selectedVariation = this.variations[0]
      } else {
        const variation = await products.variations.find(this.giftcard.product_variation_id)

        this.variations = [variation.data]
        this.selectedVariation = this.variations[0]
      }
    },
    async redeemCode() {
      try {
        this.loading = true
        await giftcard.redeem(
          this.giftcard.id,
          this.experienced_at,
          this.selectedVariation.supplier_id,
          this.selectedVariation.id
        )
        this.$bvToast.toast(`Giftcard with code ${this.giftcard.code} was succesfully redeemed.`, {
          title: 'Giftcard Redeemed',
          variant: 'primary',
        })
      } catch (error) {
        this.$bvToast.toast(`Giftcard with code ${this.giftcard.code} could not be redeemed`, {
          title: 'Invalid Giftcard',
          variant: 'danger',
        })
      }

      this.loading = false
    },
  },
}
</script>
